let Blip = function (props) {
  let { color, label, tooltip, effect, children } = props;

  return (
    <div className="mc-blip" data-effect={effect}>
      <svg width="15" height="10" data-tooltip={tooltip} aria-label={tooltip}>
        <rect width="10" height="10" rx="5" ry="5" fill={color}/>
      </svg>
      {label}
      {children}
    </div>
  );
};

module.exports = Blip;